module.exports = __webpack_public_path__ + "img/logo_wide.31a27842.jpg";